export const translations = {
  da: {
    // Navigation & Common
    nav: {
      home: 'Forside',
      services: 'Transport',
      gallery: 'Galleri',
      about: 'Om M.Rou Transport',
      contact: 'Kontakt os',
      callUs: 'Ring op',
      openMenu: 'Åbn menu',
      closeMenu: 'Luk menu',
      phone: '+45 25 30 30 16',
      contactCta: 'Kontakt os',
      servicesMenu: 'Transportydelser',
      allServices: 'Se alle transportløsninger',
      switchLang: 'Skift sprog',
      currentLang: 'Dansk',
      langDa: 'Dansk',
      langEn: 'English',
    },

    // Services Submenu / Slugs
    servicesList: {
      specialtransport: {
        title: 'Specialtransport',
        shortDesc: 'Fleksibel og professionel specialtransport af tungt og unormalt gods i både Danmark og udlandet.',
        metaTitle: 'Specialtransport - M.Rou Transport',
        metaDesc: 'Specialtransport med fokus på sikkerhed og fleksibilitet. Vi tilbyder transport af tungt, bredt og unormalt gods i hele Danmark og Europa.',
        description: '<p>M.Rou Transport tilbyder professionel og fleksibel specialtransport til opgaver, der kræver særligt udstyr, planlægning og erfaring. Vi håndterer tunge, lange og brede transporter med høj præcision og serviceminded tilgang fra start til slut.</p><p>Vores vognpark og chauffører har ekspertisen til at transportere entreprenørmateriel, store konstruktioner og unormalt gods sikkert overalt i landet samt på internationale ruter.</p><p>Ved specialtransport er omhyggelig forberedelse og korrekt godssikring altafgørende. Vi rådgiver om den bedste rute, koordinerer eventuelle nødvendige tilladelser og sørger for, at alt materiel fastspændes efter alle gældende regler og forskrifter.</p><p>Uanset om opgaven skal udføres i Jylland, på Sjælland eller på tværs af europæiske grænser, står M.Rou Transport klar med en skræddersyet løsning og direkte kontakt under hele forløbet.</p>',
        features: [
          'Tung, lang og bred specialtransport',
          'Sikker fastspænding og professionel håndtering',
          'Kørsel i både Danmark og udlandet',
          'Direkte dialog om planlægning og tidsrammer',
          'Rådgivning om ruter og logistik',
          'Fleksibel afvikling tilpasset kundens ønsker'
        ]
      },
      containerkoersel: {
        title: 'Containerkørsel',
        shortDesc: 'Effektiv og pålidelig transport samt håndtering af containere i alle størrelser.',
        metaTitle: 'Containerkørsel - M.Rou Transport',
        metaDesc: 'Effektiv og pålidelig containerkørsel i Danmark. Vi leverer og henter containere for erhverv og private med fokus på rettidighed.',
        description: '<p>Vi tilbyder fleksibel containerkørsel for både virksomheder og private. M.Rou Transport sikrer rettidig levering og sikker håndtering af dine containere i hele landet.</p><p>Hvad enten det gælder skibscontainere, affaldscontainere eller specialcontainere, tilpasser vi kørslen efter dine specifikke behov med professionelt grej og erfarne chauffører.</p><p>Vi hjælper både med enkeltstående containerflytninger og længerevarende aftaler, hvor der kræves løbende udskiftning eller tømning på byggepladser og ved erhvervsdomiciler.</p><p>Gennem direkte dialog sikrer vi, at containeren placeres præcist, hvor du har brug for den, med respekt for underlag og tilkørselsforhold.</p>',
        features: [
          'Håndtering af standard og specialcontainere',
          'Fleksibel afhentning og levering',
          'Sikker transport med erfarent mandskab',
          'Landsdækkende dækning',
          'Løbende udskiftning ved bygge- og anlægsprojekter',
          'Præcis placering efter kundens anvisninger'
        ]
      },
      stykgods: {
        title: 'Styk gods transport',
        shortDesc: 'Sikker og fleksibel transport af styk gods og pallegods tilpasset kundens ønsker.',
        metaTitle: 'Styk gods transport - M.Rou Transport',
        metaDesc: 'Sikker transport af styk gods og part loads i hele Danmark med fleksibilitet og høj pålidelighed.',
        description: '<p>Transport af styk gods kræver det rette materiel og sikker håndtering. Hos M.Rou Transport har vi stor erfaring med at flytte styk gods, paller og dellæs sikkert frem til destinationen.</p><p>Vi forstår vigtigheden af forsvarlig lastsikring og skånsom kørsel, så dit gods ankommer ubeskadiget og til aftalt tid.</p><p>Vores udstyr er gearet til at håndtere mange typer af stykgods, og vores chauffører er trænede i præcis vurdering af surringer, vægtfordeling og skånsom godstransport.</p><p>Uanset om der er tale om faste leveringer eller ad-hoc kørsel, garanterer M.Rou Transport en professionel og rettidig levering.</p>',
        features: [
          'Sikker lastsikring af styk gods og paller',
          'Erfaring med mange typer gods',
          'Fleksibel afhentning og levering',
          'Direkte kontakt til chaufføren',
          'Korrekt vægtfordeling og godssikring',
          'Skånsom transport af værdifulde forsendelser'
        ]
      },
      stoebegods: {
        title: 'Styk gods transport',
        shortDesc: 'Sikker og fleksibel transport af styk gods og pallegods tilpasset kundens ønsker.',
        metaTitle: 'Styk gods transport - M.Rou Transport',
        metaDesc: 'Sikker transport af styk gods og part loads i hele Danmark med fleksibilitet og høj pålidelighed.',
        description: '<p>Transport af styk gods kræver det rette materiel og sikker håndtering. Hos M.Rou Transport har vi stor erfaring med at flytte styk gods, paller og dellæs sikkert frem til destinationen.</p><p>Vi forstår vigtigheden af forsvarlig lastsikring og skånsom kørsel, så dit gods ankommer ubeskadiget og til aftalt tid.</p><p>Vores udstyr er gearet til at håndtere mange typer af stykgods, og vores chauffører er trænede i præcis vurdering af surringer, vægtfordeling og skånsom godstransport.</p><p>Uanset om der er tale om faste leveringer eller ad-hoc kørsel, garanterer M.Rou Transport en professionel og rettidig levering.</p>',
        features: [
          'Sikker lastsikring af styk gods og paller',
          'Erfaring med mange typer gods',
          'Fleksibel afhentning og levering',
          'Direkte kontakt til chaufføren',
          'Korrekt vægtfordeling og godssikring',
          'Skånsom transport af værdifulde forsendelser'
        ]
      },
      traepiller: {
        title: 'Træpille transport',
        shortDesc: 'Pålidelig kørsel og levering af træpiller og biomasse med professionelt tippetrailer udstyr.',
        metaTitle: 'Træpille transport - M.Rou Transport',
        metaDesc: 'Pålidelig transport og tippetrailer levering af træpiller og biomasse i hele Danmark med fokus på ren kørsel.',
        description: '<p>Vi sørger for hurtig og fleksibel transport af træpiller og løs vægt biomasse. Med vores moderne vognpark sikrer vi optimal håndtering og ren levering.</p><p>M.Rou Transport kører for både leverandører, værker og erhvervskunder med præcision og ordentlighed i hver eneste læs.</p><p>Vores tippetrailere og transportmateriel holdes rene og velholdte, så produktet bevarer sin høje kvalitet under transporten uden forurening eller spild.</p><p>Vi tilbyder både planlagte volumenleverancer og fleksibel udrykning ved akutte forsyningsbehov på tværs af det danske vejnet.</p>',
        features: [
          'Specialiseret tippetrailer udstyr',
          'Ren og effektiv tippe/aflæsningsproces',
          'Aftalte leveringstider overholdes',
          'National transport af biomasse',
          'Målrettet transport til både værker og erhverv',
          'Høj kapacitet og fleksibel planlægning'
        ]
      },
      'national-transport': {
        title: 'National transport',
        shortDesc: 'Daglig og landsdækkende godstransport i hele Danmark med højt serviceniveau.',
        metaTitle: 'National transport - M.Rou Transport',
        metaDesc: 'Landsdækkende national transport i Danmark. Vi forbinder landsdelene med pålidelig godskørsel og højt serviceniveau.',
        description: '<p>M.Rou Transport løser alle typer nationale transportopgaver i Danmark. Hvad enten det gælder faste ruter eller hasteopgaver, garanterer vi direkte kontakt og fleksibilitet.</p><p>Vi sørger for, at dit gods bliver transporteret sikkert og effektivt mellem landsdelene med udgangspunkt i vores centrale placering i Brabrand ved Aarhus.</p><p>Med kendskab til de danske veje, færgeforbindelser og logistikknudepunkter planlægger vi kørslen så ulemper undgås og leveringstiderne overholdes til punkt og prikke.</p><p>Fra enkeltpartier til fulde læs tilbyder M.Rou Transport en pålidelig og personlig transportpartner, der forstår vigtigheden af god service og aftalte rammer.</p>',
        features: [
          'Daglig kørsel i hele Danmark',
          'Fleksibel tilpasning til hasteopgaver',
          'Direkte kommunikation uden mellemled',
          'Konkurrencedygtige betingelser',
          'Pålidelig levering til aftalt tid',
          'Personlig opfølgning på enhver forsendelse'
        ]
      },
      'international-transport': {
        title: 'International transport',
        shortDesc: 'Grænseoverskridende transportløsninger i Europa med samme høje fokus på kvalitet.',
        metaTitle: 'International transport - M.Rou Transport',
        metaDesc: 'Pålidelig international godstransport i Europa. Vi sørger for sikker transport over landegrænser med høj præcision.',
        description: '<p>Vi udfører international kørsel i Europa med samme høje fokus på driftssikkerhed og personlig service som ved vores nationale opgaver.</p><p>Vores chauffører er erfarne i international kørsel og sikrer, at dit gods kommer trygt og til tiden frem over landegrænserne.</p><p>Vi koordinerer de nødvendige transportdokumenter og ruteplaner, så forsendelsen flyder gnidningsfrit igennem told- og grænsekontrolpunkter i EU.</p><p>Du har én fast kontaktperson gennem hele forløbet, hvilket gør det let at få løbende opdateringer om godsets nøjagtige position og forventede ankomsttid.</p>',
        features: [
          'Kørsel til og fra destinationer i Europa',
          'Erfarne chauffører på internationale ruter',
          'Høj sikkerhed og løbende statusopdateringer',
          'Håndtering af told og fragtdokumenter',
          'Sikker godssikring efter europæiske standarder',
          'Fleksibel planlægning ved specialopgaver'
        ]
      }
    },

    // Home Page
    home: {
      metaTitle: 'M.Rou Transport',
      metaDesc: 'M.Rou Transport tilbyder national og international transport med særligt fokus på specialtransport, containerkørsel, styk gods og træpiller.',
      heroTitle: 'Transport med fokus på',
      heroTitleHighlight: 'fleksibilitet',
      heroTitleEnd: '& service',
      heroSubtitle: 'M.Rou Transport løser både nationale & internationale transportopgaver med særlig erfaring inden for specialtransport, containere, styk gods & træpiller.',
      heroBadges: [
        'Specialtransport med høj kapacitet',
        'National & international kørsel',
        'Container- & godstransport',
        'Direkte & personlig kontakt'
      ],
      formCardTitle: 'Få et uforpligtende tilbud',
      formCardSubtitle: 'Send os en besked om din transportopgave',
      formName: 'Navn',
      formNamePlaceholder: 'Dit navn',
      formPhone: 'Telefonnummer',
      formPhonePlaceholder: 'f.eks. +45 25 30 30 16',
      formEmail: 'E-mail',
      formEmailPlaceholder: 'din@email.dk',
      formServiceType: 'Transporttype',
      formMessage: 'Kort beskrivelse',
      formMessagePlaceholder: 'Hvad skal transporteres, hvorfra og hvortil?',
      formSubmit: 'Indhent tilbud nu',
      formSubmitting: 'Sender forespørgsel...',
      formSuccessTitle: 'Mange tak for din henvendelse!',
      formSuccessDesc: 'Vi har modtaget din besked og vender tilbage til dig så hurtigt som muligt.',
      formNewMessage: 'Send en ny besked',
      formErrorGeneric: 'Der opstod en fejl under afsendelsen. Prøv venligst igen.',
      formErrorConnection: 'Der kunne ikke oprettes forbindelse til serveren. Tjek din internetforbindelse og prøv igen.',
      
      servicesSectionTitle: 'Komplette transportløsninger til dit behov',
      servicesSectionSubtitle: 'Vi tilbyder et bredt spektrum af professionelle kørselstyper med fokus på kvalitet og aftalte rammer.',
      readMoreAbout: 'Læs mere om',
      
      spotlightTitle: 'Specialtransport der kræver mere end standard',
      spotlightText1: 'Specialtransport er en af vores kernekompetencer. Vi råder over materiel og ekspertise til at håndtere udfordrende transporter, der kræver omhyggelig planlægning, særlige tilladelser og præcis udførelse.',
      spotlightText2: 'Hvad enten det drejer sig om overdimensioneret gods, maskintransport eller komplekse opgaver, sikrer M.Rou Transport en smidig og sikker proces hele vejen.',
      spotlightCta: 'Læs om specialtransport',

      networkTitle: 'National og international transport uden grænser',
      networkDesc: 'M.Rou Transport kører dagligt på de danske veje og forbinder erhvervslivet i hele landet. Samtidig tilbyder vi effektive internationale transportløsninger, der bringer dit gods sikkert på tværs af de europæiske grænser.',
      networkNationalTitle: 'National transport',
      networkNationalDesc: 'Hurtig og fleksibel kørsel på tværs af hele Danmark.',
      networkInternationalTitle: 'International transport',
      networkInternationalDesc: 'Pålidelig transport i Europa med tæt kommunikation.',
      networkNationalLink: 'Læs om national transport',
      networkInternationalLink: 'Læs om international transport',

      whyTitle: 'Hvorfor vælge M.Rou Transport?',
      whySubtitle: 'Vi prioriterer personlig kontakt, høj fleksibilitet og ordentlighed i hver eneste transportopgave.',
      why1Title: 'Fleksibel løsning af opgaven',
      why1Desc: 'Ingen opgaver er helt ens. Vi tilpasser vores kørsel og materiel nøjagtigt til din specifikke opgave.',
      why2Title: 'Direkte kontakt',
      why2Desc: 'Du taler direkte med os, der løser opgaven. Det sikrer hurtige svar og klar kommunikation undervejs.',
      why3Title: 'Professionel håndtering',
      why3Desc: 'Dine varer og gods er i trygge hænder. Vi behandler alt materiel og gods med største omhu og respekt.',

      gallerySectionTitle: 'Billeder fra vores hverdagsopgaver',
      gallerySeeMore: 'Se flere billeder',

      ctaTitle: 'Har du en transportopgave, vi skal se på?',
      ctaSubtitle: 'Kontakt os i dag for en uforpligtende snak om, hvordan vi bedst løser din kørsel med fokus på sikkerhed og kvalitet.',
      ctaSendMsg: 'Send os en besked'
    },

    // About Page
    about: {
      metaTitle: 'Om M.Rou Transport - M.Rou Transport',
      metaDesc: 'Læs om M.Rou Transport – en fleksibel og serviceminded transportpartner med stor erfaring inden for national og international kørsel.',
      headerTitle: 'Om M.Rou Transport',
      headerSubtitle: 'Din pålidelige transportpartner med fokus på fleksibilitet, direkte kontakt og høj service i alle transportopgaver.',
      mainHeading: 'Bred erfaring og stærk kundeservice',
      p1: 'M.Rou Transport er en dansk transportvirksomhed med adresse i Brabrand ved Aarhus (CVR: 42145572). Vi udfører en lang række transportopgaver for erhvervskunder og private med særligt fokus på specialtransport, containerkørsel, styk gods, træpiller samt national og international kørsel.',
      p2: 'Vores tilgang til transport er kendetegnet ved direkte dialog, fleksibilitet og ordentlighed. Hos os er du i direkte kontakt med dem, der løser opgaven, hvilket sikrer hurtige afklaringer og en smidig proces fra start til slut.',
      reliabilityHeading: 'Pålidelighed & direkte kontakt i højsædet',
      p3: 'Vi lægger afgørende vægt på, at du som kunde oplever gennemsigtighed og tryghed hele vejen igennem transportforløbet. Når du samarbejder med M.Rou Transport, slipper du for forstyrrende mellemled – du taler direkte med den ansvarlige for kørslen, hvilket sikrer hurtig og præcis kommunikation om tidsplaner, godsets status og specifikke ønsker.',
      p4: 'Vores udgangspunkt i Brabrand ved Aarhus giver os ideelle tilkørselsforhold til de centrale jyske motorveje samt direkte forbindelse til resten af Danmark og internationale ruter i Europa.',
      locationBadge: 'Lokation',
      locationAddress: '8220 Brabrand',
      locationStreet: 'Skibbyvej 35',
      cvrBadge: 'CVR-Nummer',
      cvrValue: '42145572',
      cvrSubtitle: 'Registreret virksomhed',
      focusHeading: 'Hovedfokus i hverdagen',
      focusPoints: [
        'Specialtransport af tungt og unormalt gods',
        'Containerkørsel for erhverv og private',
        'Sikker kørsel af styk gods og pallegods',
        'Transport af træpiller og biomasse',
        'National og international dækning'
      ],
      contactToday: 'Kontakt os i dag'
    },

    // Services Page
    servicesPage: {
      metaTitle: 'Transport - M.Rou Transport',
      metaDesc: 'Se vores komplette udvalg af transportløsninger – specialtransport, containerkørsel, styk gods, træpiller samt national og international transport.',
      headerTitle: 'Vores Transportløsninger',
      headerSubtitle: 'M.Rou Transport løser en lang række specialiserede og generelle transportopgaver i hele Danmark samt internationalt. Vi lægger vægt på direkte kontakt, fleksibilitet og sikker levering.',
      readMoreBtn: 'Læs mere om transportløsningen',
      needAdviceTitle: 'Har du brug for rådgivning eller et tilbud?',
      needAdviceDesc: 'Vi rådgiver gerne om den mest optimale transportløsning til netop dit gods.',
      getInTouch: 'Kontakt os for tilbud'
    },

    // Service Detail Page
    serviceDetail: {
      backToServices: 'Tilbage til alle transportydelser',
      keyBenefits: 'Nøglefordele & specifikationer',
      galleryTitle: 'Billeder fra opgaver',
      ctaBoxTitle: 'Få et uforpligtende tilbud på',
      ctaBoxDesc: 'Kontakt os direkte på telefon eller send en forespørgsel – vi vender hurtigt tilbage med en skarp pris og en klar plan for kørslen.',
      callUsNow: 'Ring til os nu',
      sendInquiry: 'Send en forespørgsel'
    },

    // Gallery Page
    gallery: {
      metaTitle: 'Galleri - M.Rou Transport',
      metaDesc: 'Se billeder af vores vognpark, lastbiler og løste transportopgaver hos M.Rou Transport.',
      headerTitle: 'Galleri & Vognpark',
      headerSubtitle: 'Se udvalgte billeder fra vores daglige kørsel, materiel og specialopgaver på vejene.',
      tabAll: 'Alle billeder',
      showingImages: 'Viser',
      imagesCount: 'billeder',
      ctaText: 'Har du brug for en transportør til dit næste projekt?',
      ctaBtn: 'Kontakt os i dag'
    },

    // Contact Page
    contact: {
      metaTitle: 'Kontakt - M.Rou Transport',
      metaDesc: 'Kontakt M.Rou Transport på telefon +45 25 30 30 16 eller e-mail mr@mrou.dk for et uforpligtende tilbud på din transportopgave.',
      headerTitle: 'Kontakt M.Rou Transport',
      headerSubtitle: 'Har du spørgsmål til en transportopgave, eller ønsker du et uforpligtende tilbud? Ring eller send os en besked.',
      companyInfoTitle: 'Virksomhedsoplysninger',
      addressLabel: 'Adresse',
      addressVal: 'Skibbyvej 35, 8220 Brabrand',
      phoneLabel: 'Telefon',
      phoneVal: '+45 25 30 30 16',
      emailLabel: 'E-mail',
      emailVal: 'mr@mrou.dk',
      hoursLabel: 'Åbningstider & Tilgængelighed',
      hoursVal: 'Mandag - Fredag: 07:00 - 17:00 (Døgnvagt ved akutte opgaver)',
      socialLabel: 'Følg os på sociale medier',
      formTitle: 'Send en besked',
      formSubtitle: 'Udfyld formularen, så kontakter vi dig hurtigst muligt.',
      nameLabel: 'Dit fulde navn',
      namePlaceholder: 'Indtast dit navn',
      phoneFieldLabel: 'Telefonnummer',
      phoneFieldPlaceholder: 'Indtast dit telefonnummer',
      emailFieldLabel: 'E-mailadresse',
      emailFieldPlaceholder: 'Indtast din e-mail',
      messageFieldLabel: 'Din besked eller opgavebeskrivelse',
      messageFieldPlaceholder: 'Beskriv opgaven, mængde, afhentnings- og leveringsadresse...',
      submitBtn: 'Send besked',
      submittingBtn: 'Sender besked...',
      successTitle: 'Mange tak for din besked!',
      successDesc: 'Vi har modtaget din henvendelse og vender tilbage hurtigst muligt.',
      sendNewBtn: 'Send en ny besked',
      errorGeneric: 'Der opstod en fejl under afsendelsen. Prøv venligst igen.',
      errorConnection: 'Der kunne ikke oprettes forbindelse til serveren. Tjek din internetforbindelse og prøv igen.'
    },

    // Footer
    footer: {
      companyDesc: 'Fleksibel og pålidelig transportpartner i Brabrand ved Aarhus med fokus på specialtransport, containere, styk gods og biomasse.',
      servicesHeading: 'Transportydelser',
      quickLinksHeading: 'Hurtige links',
      contactHeading: 'Kontakt',
      allRights: 'Alle rettigheder forbeholdes.',
      designedWith: 'Professionel transport i Danmark og Europa'
    },

    // Lightbox & 404 / 403
    lightbox: {
      close: 'Luk visning',
      prev: 'Forrige billede',
      next: 'Næste billede',
      imageAlt: 'Galleri billede'
    },
    notFound: {
      metaTitle: '404 - Siden blev ikke fundet - M.Rou Transport',
      metaDesc: 'Siden du leder efter eksisterer ikke hos M.Rou Transport.',
      title: 'Siden blev ikke fundet',
      desc: 'Beklager, den side du leder efter findes desværre ikke eller kan være blevet flyttet.',
      homeBtn: 'Gå til forsiden',
      servicesBtn: 'Se vores transportløsninger'
    },
    forbidden: {
      metaTitle: '403 - Adgang nægtet - M.Rou Transport',
      metaDesc: 'Du har ikke adgang til denne ressource hos M.Rou Transport.',
      title: 'Adgang nægtet',
      desc: 'Du har ikke den fornødne tilladelse til at se denne side eller ressource.',
      homeBtn: 'Vend tilbage til forsiden'
    }
  },

  en: {
    // Navigation & Common
    nav: {
      home: 'Home',
      services: 'Transport',
      gallery: 'Gallery',
      about: 'About M.Rou Transport',
      contact: 'Contact Us',
      callUs: 'Call us',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      phone: '+45 25 30 30 16',
      contactCta: 'Contact us',
      servicesMenu: 'Transport Services',
      allServices: 'View all transport solutions',
      switchLang: 'Switch language',
      currentLang: 'English',
      langDa: 'Dansk',
      langEn: 'English',
    },

    // Services Submenu / Slugs
    servicesList: {
      specialtransport: {
        title: 'Specialized Transport',
        shortDesc: 'Flexible and professional heavy haulage & oversized transport across Denmark and throughout Europe.',
        metaTitle: 'Specialized Transport - M.Rou Transport',
        metaDesc: 'Specialized heavy haulage with a strong focus on safety and flexibility. We transport heavy, wide, and oversized cargo throughout Denmark and Europe.',
        description: '<p>M.Rou Transport offers professional and flexible specialized transport for assignments that require special equipment, meticulous planning, and extensive expertise. We manage heavy, long, and wide cargo with superior precision and a customer-first approach from start to finish.</p><p>Our fleet and drivers possess the proven expertise to haul construction machinery, large structural elements, and abnormal loads securely nationwide and on international routes.</p><p>When executing specialized transport, thorough preparation and correct load securing are paramount. We advise on optimal routes, coordinate necessary permits, and guarantee all cargo is lashed and secured in strict compliance with current regulations.</p><p>Whether your shipment takes place in Jutland, on Zealand, or across European borders, M.Rou Transport delivers a tailored haulage solution with direct communication throughout the process.</p>',
        features: [
          'Heavy, long, and wide oversized transport',
          'Safe load securing and professional handling',
          'Haulage across Denmark and internationally in Europe',
          'Direct dialogue on scheduling and timeframes',
          'Route planning and logistics consultancy',
          'Flexible execution customized to customer requirements'
        ]
      },
      containerkoersel: {
        title: 'Container Transport',
        shortDesc: 'Efficient and reliable transport and handling of containers of all types and sizes.',
        metaTitle: 'Container Transport - M.Rou Transport',
        metaDesc: 'Efficient and dependable container transport in Denmark. We deliver and collect containers for commercial and private clients with strict punctuality.',
        description: '<p>We provide versatile container transport services for businesses as well as private individuals. M.Rou Transport ensures punctual delivery and secure handling of your containers throughout Denmark.</p><p>Whether handling shipping containers, waste containers, or specialized storage units, we adapt our haulage to your exact requirements utilizing modern equipment and seasoned drivers.</p><p>We assist with single container moves as well as ongoing agreements requiring regular swaps or emptying at construction sites and industrial premises.</p><p>Through direct dialogue, we ensure the container is positioned precisely where you need it, respecting ground conditions and access routes.</p>',
        features: [
          'Handling of standard and specialized container units',
          'Flexible pickup and delivery schedules',
          'Secure transport with highly skilled crew',
          'Nationwide Danish coverage',
          'Regular swaps for construction and civil engineering projects',
          'Accurate placement according to client specifications'
        ]
      },
      stykgods: {
        title: 'General Cargo Transport',
        shortDesc: 'Secure and flexible transport of general cargo, pallet goods, and part loads tailored to client needs.',
        metaTitle: 'General Cargo Transport - M.Rou Transport',
        metaDesc: 'Safe transport of general cargo and palletized freight across Denmark with utmost care and reliability.',
        description: '<p>Transporting general cargo requires the right equipment and careful handling. At M.Rou Transport, we have extensive experience safely moving general cargo, palletized freight, and part loads to their destination.</p><p>We understand the importance of proper load securing and gentle transit, ensuring your goods arrive undamaged and on time.</p><p>Our fleet is equipped to handle varied cargo types, and our drivers are trained in cargo lashing, weight distribution, and safe freight transit.</p><p>Whether scheduled distribution or ad-hoc shipments, M.Rou Transport guarantees professional and punctual delivery.</p>',
        features: [
          'Secure load securing of general cargo and pallets',
          'Extensive experience with diverse freight types',
          'Flexible pickup and delivery schedules',
          'Direct contact with the driver',
          'Proper weight distribution and cargo safety',
          'Careful handling of delicate shipments'
        ]
      },
      stoebegods: {
        title: 'General Cargo Transport',
        shortDesc: 'Secure and flexible transport of general cargo, pallet goods, and part loads tailored to client needs.',
        metaTitle: 'General Cargo Transport - M.Rou Transport',
        metaDesc: 'Safe transport of general cargo and palletized freight across Denmark with utmost care and reliability.',
        description: '<p>Transporting general cargo requires the right equipment and careful handling. At M.Rou Transport, we have extensive experience safely moving general cargo, palletized freight, and part loads to their destination.</p><p>We understand the importance of proper load securing and gentle transit, ensuring your goods arrive undamaged and on time.</p><p>Our fleet is equipped to handle varied cargo types, and our drivers are trained in cargo lashing, weight distribution, and safe freight transit.</p><p>Whether scheduled distribution or ad-hoc shipments, M.Rou Transport guarantees professional and punctual delivery.</p>',
        features: [
          'Secure load securing of general cargo and pallets',
          'Extensive experience with diverse freight types',
          'Flexible pickup and delivery schedules',
          'Direct contact with the driver',
          'Proper weight distribution and cargo safety',
          'Careful handling of delicate shipments'
        ]
      },
      traepiller: {
        title: 'Wood Pellet Transport',
        shortDesc: 'Reliable haulage and delivery of wood pellets and biomass utilizing professional tipper trailer equipment.',
        metaTitle: 'Wood Pellet Transport - M.Rou Transport',
        metaDesc: 'Reliable tipper trailer transport and delivery of wood pellets and bulk biomass throughout Denmark with focus on clean transport.',
        description: '<p>We provide prompt and flexible transport of wood pellets and bulk biomass. With our modern fleet, we ensure optimal handling and clean delivery.</p><p>M.Rou Transport services suppliers, heating plants, and commercial clients with precision and cleanliness on every single haul.</p><p>Our tipper trailers and haulage gear are kept impeccably clean and well-maintained so products maintain high quality throughout transit without contamination or spillage.</p><p>We offer scheduled high-volume deliveries as well as rapid dispatch for urgent supply needs across the Danish road network.</p>',
        features: [
          'Specialized clean tipper trailer equipment',
          'Clean, efficient tipping and discharge process',
          'Agreed delivery schedules strictly respected',
          'Nationwide transport of biomass materials',
          'Tailored haulage for energy plants and commercial clients',
          'High payload capacity and flexible scheduling'
        ]
      },
      'national-transport': {
        title: 'Domestic Transport',
        shortDesc: 'Daily nationwide freight transport across Denmark with a premium service standard.',
        metaTitle: 'Domestic Transport Denmark - M.Rou Transport',
        metaDesc: 'Nationwide domestic freight transport in Denmark. Connecting regions with dependable freight services and high customer care.',
        description: '<p>M.Rou Transport handles all types of domestic freight across Denmark. Whether regular scheduled routes or urgent express hauls, we guarantee direct communication and total flexibility.</p><p>We ensure your freight travels safely and efficiently between Danish regions, operating from our central hub in Brabrand near Aarhus.</p><p>With deep knowledge of Danish road networks, ferry links, and logistics hubs, we optimize routes to avoid delays and honor delivery deadlines meticulously.</p><p>From individual consignments to full truckloads, M.Rou Transport is your dependable, personal transport partner that values great service and clear agreements.</p>',
        features: [
          'Daily freight operations across all Denmark',
          'Flexible adaptation to urgent transport requests',
          'Direct communication without bureaucratic middlemen',
          'Competitive and transparent terms',
          'Dependable, on-time delivery as promised',
          'Personal follow-up on every consignment'
        ]
      },
      'international-transport': {
        title: 'International Transport',
        shortDesc: 'Cross-border transport solutions across Europe with the same high dedication to quality.',
        metaTitle: 'International Transport Europe - M.Rou Transport',
        metaDesc: 'Reliable international road haulage across Europe. Safe cross-border freight transport executed with high precision.',
        description: '<p>We execute international road transport across Europe with the same strong focus on operational reliability and personal service as our domestic operations.</p><p>Our drivers are highly experienced in cross-border European routes, ensuring your freight arrives securely and on time at international destinations.</p><p>We coordinate necessary transport documentation and transit schedules so consignments move smoothly through customs and European transit checkpoints.</p><p>You have a single dedicated contact throughout the entire shipment, making it effortless to receive real-time updates regarding location and expected arrival times.</p>',
        features: [
          'Transport to and from major European destinations',
          'Experienced drivers on international routes',
          'High security standards and ongoing status updates',
          'Management of customs and freight documentation',
          'Cargo securing compliant with European standards',
          'Flexible planning for customized transport requests'
        ]
      }
    },

    // Home Page
    home: {
      metaTitle: 'M.Rou Transport',
      metaDesc: 'M.Rou Transport provides domestic and international road haulage with specialized expertise in heavy transport, container logistics, general cargo, and wood pellets.',
      heroTitle: 'Transport focused on',
      heroTitleHighlight: 'flexibility',
      heroTitleEnd: '& dedicated service',
      heroSubtitle: 'M.Rou Transport handles domestic & international haulage with specialized expertise in heavy transport, containers, general cargo & biomass.',
      heroBadges: [
        'High-capacity specialized transport',
        'Domestic & international haulage',
        'Container & freight transport',
        'Direct & personal communication'
      ],
      formCardTitle: 'Get a Non-Binding Quote',
      formCardSubtitle: 'Send us a message about your transport requirements',
      formName: 'Full Name',
      formNamePlaceholder: 'Your name',
      formPhone: 'Phone Number',
      formPhonePlaceholder: 'e.g. +45 25 30 30 16',
      formEmail: 'Email Address',
      formEmailPlaceholder: 'your@email.com',
      formServiceType: 'Transport Type',
      formMessage: 'Brief Description',
      formMessagePlaceholder: 'What needs to be transported, from where and to where?',
      formSubmit: 'Request Quote Now',
      formSubmitting: 'Submitting request...',
      formSuccessTitle: 'Thank you for your inquiry!',
      formSuccessDesc: 'We have received your message and will get back to you as soon as possible.',
      formNewMessage: 'Send another message',
      formErrorGeneric: 'An error occurred while sending. Please try again.',
      formErrorConnection: 'Could not connect to the server. Please check your internet connection and try again.',

      servicesSectionTitle: 'Complete Transport Solutions for Every Need',
      servicesSectionSubtitle: 'We offer a wide spectrum of professional haulage services focused on quality and agreed timelines.',
      readMoreAbout: 'Read more about',

      spotlightTitle: 'Specialized Transport That Demands More Than Standard',
      spotlightText1: 'Specialized transport is one of our core competencies. We possess the fleet capacity and technical expertise to handle challenging transports requiring meticulous route planning, special permits, and exact execution.',
      spotlightText2: 'Whether oversized cargo, heavy machinery, or complex logistics, M.Rou Transport ensures a smooth and secure operation every step of the way.',
      spotlightCta: 'Read about specialized transport',

      networkTitle: 'Domestic & International Transport Without Borders',
      networkDesc: 'M.Rou Transport operates daily on Danish roads connecting businesses nationwide. Simultaneously, we provide efficient international transport solutions moving your freight securely across European borders.',
      networkNationalTitle: 'Domestic Transport',
      networkNationalDesc: 'Prompt and versatile freight operations across all of Denmark.',
      networkInternationalTitle: 'International Transport',
      networkInternationalDesc: 'Reliable road haulage in Europe with transparent communication.',
      networkNationalLink: 'Read about domestic transport',
      networkInternationalLink: 'Read about international transport',

      whyTitle: 'Why Choose M.Rou Transport?',
      whySubtitle: 'We prioritize personal contact, maximum flexibility, and absolute reliability in every transport job.',
      why1Title: 'Tailored Solutions',
      why1Desc: 'No two jobs are identical. We configure our trucks and equipment precisely to match your specific freight requirements.',
      why2Title: 'Direct Contact',
      why2Desc: 'You communicate directly with the team executing the haul. That guarantees fast answers and clear communication throughout.',
      why3Title: 'Professional Handling',
      why3Desc: 'Your goods and materials are in safe hands. We treat all equipment and cargo with the utmost care and respect.',

      gallerySectionTitle: 'Photos From Our Daily Operations',
      gallerySeeMore: 'View more photos',

      ctaTitle: 'Have a transport task we should look at?',
      ctaSubtitle: 'Contact us today for a non-binding discussion on how we can best execute your freight with uncompromising safety and quality.',
      ctaSendMsg: 'Send us a message'
    },

    // About Page
    about: {
      metaTitle: 'About M.Rou Transport - M.Rou Transport',
      metaDesc: 'Learn about M.Rou Transport – a flexible and service-minded transport partner with extensive experience in domestic and international haulage.',
      headerTitle: 'About M.Rou Transport',
      headerSubtitle: 'Your dependable transport partner focused on flexibility, direct contact, and superior service across all haulage assignments.',
      mainHeading: 'Broad Experience & Strong Customer Service',
      p1: 'M.Rou Transport is a Danish transport enterprise based in Brabrand near Aarhus (CVR: 42145572). We undertake a wide variety of transport tasks for commercial clients and private customers, with particular focus on specialized haulage, container transport, general cargo, wood pellets, as well as domestic and international freight.',
      p2: 'Our approach to haulage is distinguished by direct dialogue, flexibility, and high standards of integrity. With us, you are in direct contact with those executing the job, ensuring rapid decisions and a seamless process from origin to destination.',
      reliabilityHeading: 'Reliability & Direct Contact at the Core',
      p3: 'We place decisive emphasis on transparency and security throughout the transport workflow. When working with M.Rou Transport, there are no disruptive intermediaries – you talk directly with the person responsible for the haul, ensuring rapid and precise communication regarding timelines, freight status, and specific requirements.',
      p4: 'Our base in Brabrand near Aarhus grants us optimal access to key Danish arterial motorways, providing direct connections to the rest of Denmark as well as major European transit corridors.',
      locationBadge: 'Location',
      locationAddress: 'DK-8220 Brabrand',
      locationStreet: 'Skibbyvej 35',
      cvrBadge: 'Business Reg. (CVR)',
      cvrValue: '42145572',
      cvrSubtitle: 'Registered Danish Enterprise',
      focusHeading: 'Our Daily Focus Areas',
      focusPoints: [
        'Specialized haulage of heavy and oversized freight',
        'Container transport for commercial and private clients',
        'Secure transport of general cargo and palletized freight',
        'Haulage of wood pellets and bulk biomass',
        'Nationwide Danish and international European coverage'
      ],
      contactToday: 'Contact us today'
    },

    // Services Page
    servicesPage: {
      metaTitle: 'Transport Services - M.Rou Transport',
      metaDesc: 'Explore our complete range of transport solutions – specialized transport, container haulage, general cargo, wood pellets, and domestic & international freight.',
      headerTitle: 'Our Transport Solutions',
      headerSubtitle: 'M.Rou Transport solves a wide variety of specialized and general transport tasks across Denmark and internationally. We value direct contact, flexibility, and safe delivery.',
      readMoreBtn: 'Read more about this solution',
      needAdviceTitle: 'Need advice or a freight quote?',
      needAdviceDesc: 'We are pleased to advise on the most optimal transport solution for your specific cargo.',
      getInTouch: 'Contact us for a quote'
    },

    // Service Detail Page
    serviceDetail: {
      backToServices: 'Back to all transport services',
      keyBenefits: 'Key Benefits & Specifications',
      galleryTitle: 'Photos from operations',
      ctaBoxTitle: 'Get a non-binding quote on',
      ctaBoxDesc: 'Contact us directly by phone or submit an inquiry – we respond quickly with competitive pricing and a clear operational plan.',
      callUsNow: 'Call us now',
      sendInquiry: 'Submit an inquiry'
    },

    // Gallery Page
    gallery: {
      metaTitle: 'Gallery - M.Rou Transport',
      metaDesc: 'View photos of our fleet, heavy trucks, and completed transport assignments at M.Rou Transport.',
      headerTitle: 'Gallery & Fleet',
      headerSubtitle: 'View selected photos from our daily operations, haulage equipment, and specialized assignments on the road.',
      tabAll: 'All photos',
      showingImages: 'Showing',
      imagesCount: 'photos',
      ctaText: 'Need a trusted haulage partner for your next transport?',
      ctaBtn: 'Contact us today'
    },

    // Contact Page
    contact: {
      metaTitle: 'Contact Us - M.Rou Transport',
      metaDesc: 'Contact M.Rou Transport by phone at +45 25 30 30 16 or email mr@mrou.dk for a non-binding quote on your transport needs.',
      headerTitle: 'Contact M.Rou Transport',
      headerSubtitle: 'Have questions regarding a transport task, or need a non-binding quote? Call us or send a message.',
      companyInfoTitle: 'Company Information',
      addressLabel: 'Address',
      addressVal: 'Skibbyvej 35, DK-8220 Brabrand, Denmark',
      phoneLabel: 'Phone',
      phoneVal: '+45 25 30 30 16',
      emailLabel: 'Email',
      emailVal: 'mr@mrou.dk',
      hoursLabel: 'Opening Hours & Availability',
      hoursVal: 'Monday - Friday: 07:00 - 17:00 (24/7 on-call for urgent jobs)',
      socialLabel: 'Follow us on social media',
      formTitle: 'Send a Message',
      formSubtitle: 'Fill out the form below and we will contact you as quickly as possible.',
      nameLabel: 'Your Full Name',
      namePlaceholder: 'Enter your name',
      phoneFieldLabel: 'Phone Number',
      phoneFieldPlaceholder: 'Enter your phone number',
      emailFieldLabel: 'Email Address',
      emailFieldPlaceholder: 'Enter your email address',
      messageFieldLabel: 'Your Message or Transport Description',
      messageFieldPlaceholder: 'Describe your freight, dimensions, weight, pickup and delivery address...',
      submitBtn: 'Send Message',
      submittingBtn: 'Sending message...',
      successTitle: 'Thank you for reaching out!',
      successDesc: 'We have received your inquiry and will get back to you promptly.',
      sendNewBtn: 'Send another message',
      errorGeneric: 'An error occurred while sending. Please try again.',
      errorConnection: 'Could not connect to the server. Please check your internet connection and try again.'
    },

    // Footer
    footer: {
      companyDesc: 'Flexible and reliable haulage partner based in Brabrand near Aarhus, specializing in heavy transport, containers, general cargo, and biomass.',
      servicesHeading: 'Transport Services',
      quickLinksHeading: 'Quick Links',
      contactHeading: 'Contact',
      allRights: 'All rights reserved.',
      designedWith: 'Professional freight transport in Denmark & Europe'
    },

    // Lightbox & 404 / 403
    lightbox: {
      close: 'Close preview',
      prev: 'Previous photo',
      next: 'Next photo',
      imageAlt: 'Gallery photo'
    },
    notFound: {
      metaTitle: '404 - Page Not Found - M.Rou Transport',
      metaDesc: 'The page you are looking for does not exist at M.Rou Transport.',
      title: 'Page Not Found',
      desc: 'Sorry, the page you are looking for does not exist or may have been relocated.',
      homeBtn: 'Go to Homepage',
      servicesBtn: 'View our transport solutions'
    },
    forbidden: {
      metaTitle: '403 - Access Denied - M.Rou Transport',
      metaDesc: 'You do not have access to this resource at M.Rou Transport.',
      title: 'Access Denied',
      desc: 'You do not have the required permissions to access this page or resource.',
      homeBtn: 'Return to Homepage'
    }
  }
}
